import React, { FC, ReactElement } from 'react';
import { Provider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Intl } from '@erecruit/core';
import { Spinner } from '@erecruit/ui-kit';

import '@erecruit/ui-kit/dist/main.css';

import './adapters';
import App, { AppContainer } from './App';
import configureStore from './redux/store';
import getUserManager, {
  initializeUserManager,
} from './security/oidcUserManager';
import CallbackPage from './components/Oidc/Callback';
import customMessages from './messages';
import { useAppConfig, AppConfig } from './appConfig';

// TODO: add api dependency which has token
const Main = (): ReactElement => (
  <AppInitializer>
    {(appConfig: AppConfig) => {
      initializeUserManager(appConfig);
      const store = configureStore({});

      return (
        <Provider store={store}>
          <OidcProvider store={store} userManager={getUserManager()}>
            {/* TODO make dynamic locales for react-intl */}
            <Intl.IntlProvider
              locale="en-US"
              defaultLocale="en-US"
              messages={customMessages}
            >
              <BrowserRouter basename={appConfig.REACT_APP_BASE_URL || '/'}>
                <Switch>
                  <Route path="/auth/callback" component={CallbackPage} />
                  <Route path="/" component={App} />
                </Switch>
              </BrowserRouter>
            </Intl.IntlProvider>
          </OidcProvider>
        </Provider>
      );
    }}
  </AppInitializer>
);

interface AppInitializerProps {
  children: (appConfig: AppConfig) => React.ReactNode;
}

const AppInitializer: FC<AppInitializerProps> = ({ children }) => {
  const config = useAppConfig();
  return !config ? (
    <AppContainer>
      <Spinner size="large" />
    </AppContainer>
  ) : (
    <>{children(config)}</>
  );
};

export default Main;
